"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressOverlayLoaderIndicator = exports.PleaseWaitOverlayLoaderIndicator = void 0;
var please_wait_1 = require("./please-wait");
Object.defineProperty(exports, "PleaseWaitOverlayLoaderIndicator", { enumerable: true, get: function () { return please_wait_1.PleaseWaitOverlayLoaderIndicator; } });
var progress_1 = require("./progress");
Object.defineProperty(exports, "ProgressOverlayLoaderIndicator", { enumerable: true, get: function () { return progress_1.ProgressOverlayLoaderIndicator; } });
//# sourceMappingURL=index.js.map